<template>
    <div class="meal-popup">
        <button type="button" class="popup-close icon-close" @click="$emit('onClose')"></button>
        <div class="item__inner">
            <div class="item__thb">
                <div class="item__thb__sizer">
                    <img :src="meal.img" v-if="meal.img" />
                </div>
            </div>
            <span v-html="sierotki(meal.name)" class="name"></span>
            <div class="item__options">
                <strong v-text="translate('popup_optional')"></strong>

                <div class="select-desktop" v-if="!isMobile">
                    <v-select v-if="meal.additives && meal.additives.length > 0" :placeholder="translate('popup_no_additive')" label="name" :options="additivesOptions" @input="selectAdditive">
                        <template #no-options="{ search, searching, loading }">{{ translate('popup_not_found') }}</template>
                    </v-select>
                </div>
                <div class="select-mobile style-select" v-if="meal.additives && meal.additives.length > 0 && isMobile">
                    <select v-model="selectedAdditiveM" @change="selectAdditive(selectedAdditiveM)">
                        <option :value="null">{{translate('popup_no_additive')}}</option>
                        <option v-for="(additive, index) in additivesOptions" :key="index" :value="additive">{{additive.name}}</option>
                    </select>
                </div>
                <div class="select-desktop" v-if="!isMobile">
                    <v-select v-if="meal.souce && meal.souce.length > 0" :placeholder="translate('popup_sauce_none')" label="name" :options="meal.souce" @input="selectSouce">
                        <template #no-options="{ search, searching, loading }">{{ translate('popup_not_found') }}</template>
                    </v-select>
                </div>
                <div class="select-mobile style-select" v-if="meal.souce && meal.souce.length > 0 > 0 && isMobile">
                    <select v-model="selectedSouceM" @change="selectSouce(selectedSouceM)">
                        <option :value="null">{{ translate('popup_sauce_none') }}</option>
                        <option v-for="(souce, index) in meal.souce" :key="index" :value="souce">{{souce.name}}</option>
                    </select>
                </div>

                <button type="button" class="btn btn--block" @click="suggestBeer"><span v-text="translate('popup_cta')"></span></button>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {translate} from "@/helpers/helpers";

const isTablet = window.matchMedia('only screen and (max-width: 768px)').matches;
const isMobile = window.innerWidth < 651 || isTablet;

// const isMobile = true;

export default {
    name: "meal-popup",
    components: {
        vSelect
    },
    props: ['meal', 'additives'],
    data() {
        return {
            suggestedBeer: null,
            selectedAdditive: null,
            selectedAdditiveM: null,
            selectedSouce: null,
            selectedSouceM: null,
            isMobile: isMobile
        }
    },
    created() {
        this.suggestedBeer = this.meal.beer;
    },
    computed: {
        additivesOptions() {
            if(this.meal.additives.length > 0) {
                return this.meal.additives.map(id => ( this.additives.find(obj => obj.id === id )));
            }
            return [];
        }
    },
    methods: {
        translate: translate,
        selectAdditive(value) {
            if(value !== null) {
                this.selectedAdditive = value.name;
            }else{
                this.selectedAdditive = null;
            }
        },
        selectSouce(value) {
            if(value !== null) {
                this.selectedSouce = value.name;

                if(value.beer) {
                    this.suggestedBeer = value.beer;
                }else{
                    this.suggestedBeer = this.meal.beer;
                }
            }else{
                this.selectedSouce = null;
                this.suggestedBeer = this.meal.beer;
            }
        },
        suggestBeer() {
            let name = this.sierotki(this.meal.name);
            if(this.selectedAdditive) {
                name += ', ' + this.selectedAdditive.toLowerCase();
            }
            if(this.selectedSouce) {
                name += ', ' + this.selectedSouce.toLowerCase()
            }

            this.$emit('onSuggestBeer', this.suggestedBeer, name)
        }
    }
}
</script>

<style scoped>

</style>